export function printOffer(e: Event, index: any) {
    const formDiv = (document.querySelectorAll('.sp-offers-item')[index] || document.querySelectorAll('.offers-block-item')[index]) as HTMLDivElement;
    // Create an iframe element
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    const iframeDoc = iframe.contentWindow?.document;

    if (iframeDoc) {
        iframeDoc.open();
        writePrintHead(iframeDoc);
        writePrintBodyStart(iframeDoc);
        if (formDiv?.classList?.contains("offers-block-item")) {
            const convertedElement = convertToFirstReference(formDiv);
            if (convertedElement?.innerHTML) {
                iframeDoc.write(convertedElement.innerHTML);
            }
        } else if (formDiv?.innerHTML) {
            iframeDoc.write(formDiv.innerHTML);
        }
        writePrintBodyEnd(iframeDoc);
        iframeDoc.close();

        // Wait for the iframe content to load before printing
        iframe.onload = function () {
            try {
                const contentWindow = iframe.contentWindow;
                if (contentWindow) {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                } else {
                    console.log("Content window is not available.");
                }
            } catch (error) {
                console.log("err", error)
            }
        };

            // Additional error handling for onload event
            iframe.onerror = function (errorEvent) {
                console.log(errorEvent);
            };

    } else {
        alert('Printing is blocked by the browser. Please allow pop-ups for this site to print the offer.');
    }
}

function writePrintHead(iframeDoc: Document) {
    iframeDoc.write('<html><head>');
    const cssLinks = [
        '/brand/_assets/css/service.css',
        '/brand/_assets/css/main.css',
        '/brand/_assets/css/brand-config.css',
        '/brand/_assets/css/header.css',
        '/brand/_assets/css/footer.css',
        '/brand/_assets/css/glossary.css'
    ];
    cssLinks.forEach(link => {
        iframeDoc.write(`<link rel="stylesheet" type="text/css" href="${link}" media="all">`);
    });
    iframeDoc.write(`<style>
        @page {
            margin:10mm;
        }
        * {
            -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
            color-adjust: exact !important;                 /*Firefox*/
        }
        .claim-offer{
            display:none
        }
        @media print {
            @-moz-document url-prefix() {
                .btn-group li {
                    display: none !important;
                }
                .btn-group li:first-child {
                    display: block !important;
                }
            }
            .sp-offers-main {
                padding: 1rem !important;
            }
            .sp-offers-section .sp-offers-main .sp-offers-details {
                display: flex !important;
                flex-direction: column !important;
                gap: 8px !important;
                align-items: center !important;
                width: 100% !important;
            }
            .block-offer {
                font-size: 24px !important;
                font-weight: 700 !important;
                line-height: 45px !important;
                text-align: center !important;
            }
            .offers-block-desc {
                font-size: 18px !important;
                font-weight: 400 !important;
                line-height: 1.75rem !important;
                text-align: center !important;
            }

            .offers-block-disclaimer {
                background-image: linear-gradient(90deg, hsla(0, 0%, 100%, .5) 60%, hsla(0, 0%, 100%, 0) 0) !important;
                background-position: top !important;
                background-repeat: repeat-x !important;
                background-size: 20px 1px !important;
                font-size: 8px !important;
                font-weight: 400 !important;
                margin-top: .5rem !important;
                padding-top: .5rem !important;
            }
    
            .offers-block-disclaimer p {
                display: block !important;
                visibility: visible !important;
                margin: 0 !important;
                padding: 0 !important;
            }
    
            .offers-block-disclaimer p a {
                display: inline !important;
                visibility: visible !important;
                text-decoration: none !important;
            }
    
            .offers-block-expire {
                display: block !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                line-height: 1rem !important;
                margin-top: .5rem !important;
                text-align: center !important;
            }

            .sp-offers-section .container .claim-offer {
                display: none !important;
            }            
            .offers-block-disclaimer,
            .offers-block-disclaimer *,
            .offers-block-disclaimer p,
            .offers-block-main .offers-block-expire,
            .offers-block-expire {
                color: inherit !important;
                -webkit-text-fill-color: inherit !important;
            }
        }
        </style>`);
    iframeDoc.write('</head>');
}

function writePrintBodyStart(iframeDoc: Document) {
    iframeDoc.write('<body>');
    iframeDoc.write('<section class="sp-offers-section">');
    iframeDoc.write('<div class="container">');
    iframeDoc.write('<ul class="sp-offers-list">');
}

function writePrintBodyEnd(iframeDoc: Document) {
    iframeDoc.write('</div>');
    iframeDoc.write('</ul>');
    iframeDoc.write('</section>');
    iframeDoc.write('</body></html>');
}

export function convertToFirstReference(htmlElement: HTMLElement): HTMLElement {
    const liElement = document.createElement('li');
    liElement.classList.add('sp-offers-item');
    const mainDiv = document.createElement('div');
    mainDiv.classList.add('sp-offers-main');
    const dataDiv = document.createElement('div');
    dataDiv.classList.add('sp-offers-data');

    const detailsDiv = document.createElement('div');
    detailsDiv.classList.add('sp-offers-details');

    const brandLogoImg = htmlElement.querySelector('.brand-logo')?.cloneNode(true) as HTMLImageElement;

    const blockOfferParagraph = htmlElement.querySelector('.block-offer')?.cloneNode(true) as HTMLParagraphElement;

    const offersBlockDescParagraph = htmlElement.querySelector('.offers-block-desc')?.cloneNode(true) as HTMLParagraphElement;

    detailsDiv.appendChild(brandLogoImg);
    detailsDiv.appendChild(blockOfferParagraph);
    detailsDiv.appendChild(offersBlockDescParagraph);
    dataDiv.appendChild(detailsDiv);

    const disclaimerDiv = htmlElement.querySelector('.offers-block-disclaimer')?.cloneNode(true) as HTMLDivElement;
    const expireBlockSpan = htmlElement.querySelector('.offers-block-expire')?.cloneNode(true) as HTMLSpanElement;
    const watermarkBlockImg = htmlElement.querySelector('.offers-watermark')?.cloneNode(true) as HTMLImageElement;

    mainDiv.appendChild(dataDiv);

    if(disclaimerDiv){
        mainDiv.appendChild(disclaimerDiv);
    }

    if(expireBlockSpan){
        mainDiv.appendChild(expireBlockSpan);
    }

    if(watermarkBlockImg){
        mainDiv.appendChild(watermarkBlockImg);
    }
    const claimBlockOfferAnchor = htmlElement.querySelector('.claim-offer')?.cloneNode(true) as HTMLAnchorElement;
    liElement.appendChild(mainDiv);
    if (claimBlockOfferAnchor) {
        liElement.appendChild(claimBlockOfferAnchor);
    }
    return liElement;
}